import React, { useState } from "react";
import RequestService from "../../../services/request.service";

// import { useNavigate } from "react-router"
// import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import { toast } from 'react-toastify'



import moment from 'moment'


import Dialog from '../../../services/Dialogs'
import { Button, Modal } from 'react-bootstrap'


import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import { SERVER_ } from  '../../../config';


const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u

const curp2date = (curp:any) => {
  var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
  //miFecha = new Date(año,mes,dia) 
  var anyo = parseInt(m[1],10)+1900;
  if( anyo < 1950 ) anyo += 100;
  var mes = parseInt(m[2], 10)-1;
  var dia = parseInt(m[3], 10);
  return moment(new Date( anyo, mes, dia )).format('YYYY-MM-DD');
}

const ModalEditarAsesor = ( props ) => {

  const dialog = new Dialog();


  const { show, onHide, asesor } = props


var mensaes_validacion_generico = 'Este campo es obligatorio'


const schema = yup.object().shape({


  // # id, uuid, activo, 
  // username: yup.string().required(mensaes_validacion_generico).matches(/^[a-zA-Z0-9]+$/,'La contraseña solo puede tener letras y números. No se aceptan espacios ni caracteres especiales'),
  // pwd: yup .string().required('La contraseña es obligatoria') .matches( /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, "Debe contener 8 carácteres, 1 mayúscula, 1 minúscula, 1 número y un caracter especial como: * ! % $ & " ),
  //   changepassword: yup.string().required().when("pwd", {
  //     is: val => (val && val.length > 0 ? true : false),
  //     then: yup.string().oneOf(
  //       [yup.ref("pwd")],
  //       "Las contraseñas NO coinciden"
  //     )
  //   }),
  curp: yup.string().required(mensaes_validacion_generico).matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),
  email: yup.string().required(mensaes_validacion_generico).email('Formato de Email no valido').required('Este campo es obligatorio'),
  celular: yup.string().required(mensaes_validacion_generico).matches(/^\d{10}$/,"Formato no valido"),

  nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
  paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
  materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido"),

  direccion: yup.string().required(),

  fecha_ingreso: yup.string().required(),

  // idsucursal: yup.string().required(),
  // idsucursal: yup.number().required(),

  rol: yup.string().required(mensaes_validacion_generico),

  idgerente: yup.string().required(mensaes_validacion_generico),

  // terms: yup.bool().required().oneOf([true], 'Los terminos y condiciones deben ser aceptadas'),
});



const guardarCambios = async (nuevo_usuario:any,event:any,) =>{
      await dialog.open({
        accept: 'Actualizar Usuario',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
        // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
        target: event.target,
        template: `
          <dl>
            <dt>Nombre</dt>
            <dd>`+nuevo_usuario.nombres+` `+nuevo_usuario.paterno+` `+nuevo_usuario.materno+`</dd>
            <dt>CURP</dt>
            <dd>`+nuevo_usuario.curp+`</dd>
            <dt>Celular</dt>
            <dd>`+nuevo_usuario.celular+`</dd>
            <dt>Correo Electrónico</dt>
            <dd>`+nuevo_usuario.email+`</dd>
          </dl>
        `
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        setSeEnvio(true)
        // console.log('lo que se envia es:', nuevo_usuario)
        try{

        let res_nuevo_usuario = await RequestService.update('recursos_humanos/cambiar_informacion/'+asesor.uuid, { ...nuevo_usuario, fecha_nacimiento : curp2date(nuevo_usuario.curp) })

        if(res_nuevo_usuario){
          toast.warning('Los cambios se hicieron')
          // onHide()
        }
        else{
          toast.error('Error al crear usuario en el servidor')
        }  

        }
        catch(e:any){
          toast.error(e.response.data)
        }

        
      }
     
}

const [ envio_server, setSeEnvio ] = useState<boolean>(false)


	return (
		<>

      <Modal show={show} size="lg" backdrop="static" onHide={onHide} animation={true}>

        <Modal.Header closeButton>
          <Modal.Title>
          	<small>Cambiar los datos de Usuario</small>
          </Modal.Title>
        </Modal.Header>


        <Modal.Body>

              <Formik
                validationSchema={schema}
                onSubmit={(values,e)=>{guardarCambios(values, e)}}
                initialValues={{

                celular:  asesor.celular,
                email:  asesor.email,

                curp:  asesor.curp||'',
                nombres:  asesor.nombres,
                paterno:  asesor.paterno,
                materno:  asesor.materno,

                direccion:  asesor.direccion,

                fecha_ingreso:  new Date(moment(asesor.fecha_ingreso).toString()),

                idgerente:  asesor.idgerente.uuid,
                rol:  asesor.rol,

                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>

                  
                  {
                    // JSON.stringify(values)
                  }

                    <h5>Información Personal</h5>

                    <Row >
                      <Form.Group as={Col} md="4" className="mb-3" controlId="nombres">
                        <Form.Label>Nombre(s)</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          name="nombres"
                          value={values.nombres}
                          onChange={(e)=>{ setFieldValue('nombres', (e.target.value || "").toUpperCase()) }}
                          isInvalid={!!errors.nombres}
                        />
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid"> {errors.nombres} </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="4" className="mb-3" controlId="paterno">
                        <Form.Label>Apellido Paterno</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          name="paterno"
                          value={values.paterno}
                          onChange={(e)=>{ setFieldValue('paterno', (e.target.value || "").toUpperCase()) }}
                          isInvalid={!!errors.paterno}
                        />
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid"> {errors.paterno} </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="4" className="mb-3" controlId="materno">
                        <Form.Label>Apellido Materno</Form.Label>
                        <Form.Control
                          type="text"
                          name="materno"
                          value={values.materno}
                          onChange={(e)=>{ setFieldValue('materno', (e.target.value || "").toUpperCase()) }}
                          isInvalid={!!errors.materno}
                        />

                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid"> {errors.materno} </Form.Control.Feedback>
                      </Form.Group>
                    </Row>



                    <Row >
                      <Form.Group as={Col} md="6" className="mb-3" controlId="curp">
                        <Form.Label>CURP </Form.Label>
                        <Form.Control
                          type="text"
                          required
                          name="curp"
                          value={values.curp}
                          onChange={(e)=>{ setFieldValue('curp', (e.target.value || "").toUpperCase()) }}
                          isInvalid={!!errors.curp}
                        />
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid"> {errors.curp  } </Form.Control.Feedback>
                      </Form.Group>
                      <Col md="3">
                        { 
                          REG_CURP.test(values.curp) &&(
                        <div className="mb-3">
                          <label className="form-label">Sexo</label>
                          <input type="text" readOnly value={values.curp.substr(10,1)==='H'?'HOMBRE':'MUJER'} className="form-control" />
                        </div>
                          )
                        }
                      </Col>
                      <Col md="3">
                        { 
                          REG_CURP.test(values.curp) &&(
                        <div className="mb-3">
                          <label className="form-label">Fecha de Nacimiento</label>
                          <input type="text" readOnly value={curp2date(values.curp)} className="form-control" />
                        </div>
                          )
                        }
                      </Col>
                    </Row>


                    <hr/>


                    <h5>Información de Contacto</h5>

            <Form.Group  className="mb-3" controlId="direccion">
              <Form.Label>Dirección Completa</Form.Label>
              <Form.Control
                as="textarea"
                type="text"
                required
                name="direccion"
                value={values.direccion}
                onChange={(e)=>{ setFieldValue('direccion', e.target.value.toUpperCase() ) }}
                isInvalid={!!errors.direccion}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.direccion} </Form.Control.Feedback>
            </Form.Group>




                    <Row>
                      <Form.Group as={Col} md="7" className="mb-3" controlId="email">
                        <Form.Label>Correo Electrónico</Form.Label>
                        <Form.Control
                          type="email"
                          required
                          name="email"
                          value={values.email}
                          onChange={(e)=>{ setFieldValue('email', e.target.value ) }}
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid"> {errors.email} </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="5" className="mb-3" controlId="celular">
                        <Form.Label>Celular</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          name="celular"
                          value={values.celular}
                          onChange={(e)=>{ setFieldValue('celular',e.target.value) }}
                          isInvalid={!!errors.celular}
                        />
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid"> {errors.celular} </Form.Control.Feedback>
                      </Form.Group>
                    </Row>







                    {
                      !false && (
                            <div className="mb-3 d-grid">
                                    <Button className="btn-lg" type="submit">Guardar Cambios</Button>
                            </div>
                      )
                    }
                    
                  </Form>
                )}
              </Formik>



        </Modal.Body>



      </Modal>

		</>
	)

}



export default ModalEditarAsesor



